import React from 'react'
import { Row } from 'antd'
import { BigSale } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import styles from './SaleClientDetails.module.scss'
import { CustomTitle, CustomCol } from 'src/components'
import { getSaleBejalfOf, getSaleCertificateLanguage } from 'src/core/helpers'

const SaleClientDetails: React.FC<{ sale: BigSale }> = ({ sale }) => {
  const { t } = useTranslation()
  const isTransfer = sale.fulfillment_type === 'transfer'
  const isBiodiversity = sale.projectKind === 'biodiversity'

  const bejalfLabel = {
    CUSTOM: t('Transactions.OffetBejalf'),
    TRANSFER: t('Transactions.TransferCreditsTo'),
    BIODIVERSITY: t('Transactions.CertificateBejalf')
  }[isTransfer ? 'TRANSFER' : isBiodiversity ? 'BIODIVERSITY' : 'CUSTOM']

  const labels = [
    {
      label: bejalfLabel,
      secondLabel: getSaleBejalfOf(sale),
      isVisible: true,
    },
    {
      label: !isTransfer ? t('Transactions.OffsetLanguage') : t('Transactions.TransferToAccountID'),
      secondLabel: !isTransfer ? getSaleCertificateLanguage(sale, t) : sale.account_id,
      isVisible: true,
    },
    {
      label: !isTransfer ? t('Transactions.ReasonOfCompensation') : t('Transactions.TypeOfPurchase'),
      secondLabel: !isTransfer ? sale.offsetReason : t('Transactions.CreditTransfer'),
      isVisible: sale.projectKind !== 'biodiversity',
    }
  ]

  return  <>
    <CustomTitle label={t('Transactions.Client')} type={null} />
    {labels.map((x, idx) => {
      if (!x.isVisible) return
      return <Row key={idx}>
        <CustomCol>
          <CustomTitle
            label={x.label}
            type={null}
          />
        </CustomCol>
        <CustomCol className={styles.text}>
          <CustomTitle
            label={x.secondLabel || '-'}
            type={null}
          />
        </CustomCol>
      </Row>
    })}
  </>
}

export default SaleClientDetails
